<div class="">
    <section class="section-card">
        <form name="contactDetailsForm" (ngSubmit)="contactDetailsForm.valid" #contactDetailsForm="ngForm" novalidate>
            <div class="row">
                <div class="d-flex">
                    <h2 class="page_heading"><u>{{liveRfpData.rfpCode}} </u></h2>
                    <button type="button" class="button-box"
                        [ngStyle]="{'color': getStatusColor(liveRfpData.rfpStatus) ,'font-size': '18px'}">{{liveRfpData.rfpStatus}}</button>
                </div>
                <div class="col-md-7 col-lg-7 col-sm-7 col-12 my-3 outer-borders">
                    <div class="row">
                        <div class="col-lg-4 col-12">
                            <p><strong>Type : </strong>{{liveRfpData.rfpTypeName}}</p>
                        </div>
                        <div class="col-lg-4 col-12">
                            <p><strong>RFP Name : </strong>{{liveRfpData.rfpTypeFor}}</p>
                        </div>
                        <div class="col-lg-4 col-12">
                            <p><strong>RFP code : </strong>{{liveRfpData.rfpCode}}</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-4 col-12">
                            <p><strong>Start date : </strong>{{liveRfpData.rfpStartDate | date: 'dd-MM-yyyy'}} </p>
                        </div>
                        <div class="col-lg-4 col-12">
                            <p><strong>Start time : </strong>{{liveRfpData.rfpStartTime }}{{startTime}}</p>
                        </div>
                        <div class="col-lg-4 col-12">
                            <p><strong>End Date : </strong>{{liveRfpData.rfpEndDate | date: 'dd-MM-yyyy'}}</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-4 col-6">
                            <p><strong>End Time : </strong>{{liveRfpData.rfpEndTime}}{{endTime}}</p>
                        </div>
                        <div class="col-lg-4 col-6">
                            <p><strong>Commercial Wastage : </strong>{{liveRfpData.rfpCommercialWeightage}}</p>
                        </div>
                        <div class="col-lg-4 col-6">
                            <p><strong>Technical Wastage : </strong>{{liveRfpData.rfpTechnicalWeightage}}</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-4 col-6">
                            <p><strong>Billing Address : </strong>{{liveRfpData.rfpBillingAddress}}</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-5 col-lg-5 col-sm-5 col-12">
                    <div class="card-body">
                        <!-- <div class="row" style="background-color:#d62828;">
                            <div class="col-lg-3 col-12">
                                <p class="head"><strong>Days : </strong>{{ dateDifference.days }}</p>
                            </div>
                            <div class="col-lg-3 col-12">
                                <p class="head"><strong>Hours : </strong>{{ formattedHours }}</p>
                            </div>
                            <div class="col-lg-3 col-12">
                                <p class="head"><strong>Minutes : </strong>{{ formatedMinutes }}</p>
                            </div>
                            <div class="col-lg-3 col-12">
                                <p class="head"><strong>Seconds : </strong>{{ formatedSeconds }}</p>
                            </div>
                        </div> -->
                        <div class="row">
                            <div class="count-down-timer">
                                <div class="wrapper">
                                  <div class="description">
                                    <p>Days</p>
                                    <p>Hours</p>
                                    <p>Minutes</p>
                                    <p>Seconds</p>
                                  </div>
                                  <div class="times">
                                    <p #days></p>
                                    <p #hours></p>
                                    <p #minutes></p>
                                    <p #seconds></p>
                                  </div>
                                </div>
                              </div>
                        </div>
                    </div>
                    <div class="mx-auto d-flex">
                        <button type="button" class="boxSecond">Not Interested</button>
                    </div>
                    <div class="form-group mt-3 mx-3">
                        <label for="document" class="form-label  mandatory">Document</label>
                        <input type="file" class="form-control" name="document" id="rfp_FileUpload"
                            [(ngModel)]="contact.rfp_FileUpload" #rfp_FileUpload="ngModel" required
                            [ngClass]="{ 'is-invalid': contactDetailsForm.submitted && rfp_FileUpload.errors }"
                            (change)="onFileSelected($event)" placeholder="Employee Document"
                            accept=".doc,.xlsx,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.rfp_FileUpload, application/pdf">
                        <mat-icon class="mat_download imgEmp" style="color:#063178"
                            (click)="downloadContact($event)">file_download</mat-icon>
                        <div *ngIf="contactDetailsForm.submitted && rfp_FileUpload.errors" class="invalid-feedback">
                            <div *ngIf="rfp_FileUpload.errors['required']"> Document is required.</div>
                        </div>
                    </div>


                </div>
            </div>

            <fieldset>
                <div class="row businessDetailPage  justify-content-between">
                    <div class="col-md-4">
                        <label for="lead_time" class="form-label mandatory">Lead Time</label>
                        <div class="form-group">
                            <input type="text" class="form-control" name="lead_time" id="lead_time"
                                [(ngModel)]="contact.lead_time" #lead_time="ngModel" required
                                [ngClass]="{'is-invalid': (lead_time.touched || contactDetailsForm.submitted) && lead_time.errors}">
                            <div *ngIf="(lead_time.touched || contactDetailsForm.submitted) && lead_time.errors"
                                class="invalid-feedback">
                                <div *ngIf="lead_time.errors?.['required']">Lead Time is required</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="credit_days" class="form-label mandatory">Credit days</label>
                            <input type="text" class="form-control" name="credit_days" #credit_days="ngModel"
                                [ngClass]="{'is-invalid': (credit_days.touched || contactDetailsForm.submitted)&& lead_time.errors}"
                                [(ngModel)]="contact.credit_days" id="credit_days" required>
                            <div *ngIf="(credit_days.touched || contactDetailsForm.submitted) && credit_days.errors"
                                class="invalid-feedback">
                                <div *ngIf="credit_days.errors?.['required']">Credit days is required
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="remark" class="form-label mandatory">RFP Remark</label>
                            <textarea class="form-control" disabled rows="3">{{liveRfpData.remark}}</textarea>
                            <!-- <textarea type="text" class="form-control" name="remark" id="remark" rows="3"
                                #remark="ngModel" [(ngModel)]="contact.remark"
                                [ngClass]="{'is-invalid': (remark.touched || contactDetailsForm.submitted) && remark.errors}"
                                style="overflow: hidden;" required></textarea>
                            <div *ngIf="(remark.touched || contactDetailsForm.submitted) && remark.errors"
                                class="invalid-feedback">
                                <div *ngIf="remark.errors?.['required']">Remark is required.</div>
                            </div> -->
                        </div>
                    </div>
                </div>

                <div class="row mt-3 mx-0">
                    <table class="table table-bordered tableBusiness">
                        <thead class="table-dark">
                            <tr>
                                <th>Sr. No.</th>
                                <th>Product / service name</th>
                                <th *ngFor="let header of productheader">{{header.priceParameterName}}</th>
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of vendorEmployees; let i = index">
                                <td>{{i+1}}</td>
                                <td>{{item.itemName}}</td>
                                <td *ngFor="let header of productheader">
                                    <input type="number" class="form-control" name="{{header.priceParameterName}}{{i}}"
                                        [(ngModel)]="item[header.priceParameterName]"
                                        (ngModelChange)="calculateItemSum(item)">
                                </td>
                                <td>
                                    <input type="number" disabled class="form-control" [value]="item.calculatedSum">
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>


                <div class="row businessDetailPage mt-3">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="additional_charges" class="form-label mandatory">Additional Charges</label>
                            <input type="number" class="form-control" name="additional_charges" id="additional_charges"
                                #additional_charges="ngModel" [(ngModel)]="contact.additional_charges"
                                [ngClass]="{'is-invalid': (additional_charges.touched || contactDetailsForm.submitted) && additional_charges.errors}"
                                required>
                            <div *ngIf="(additional_charges.touched || contactDetailsForm.submitted) && additional_charges.errors"
                                class="invalid-feedback">
                                <div *ngIf="additional_charges.errors?.['required']">Additional Charges
                                    is required.</div>
                                <!-- <div *ngIf="mailId.errors?.['pattern']">Valid Contact Number is required.</div> -->
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="total_charges" class="form-label mandatory">Total Charges</label>
                            <!-- <input type="number" [value]="calculateItemTotal()" disabled class="form-control" name="total_charges" id="total_charges" #total_charges="ngModel"
                                [(ngModel)]="contact.total_charges" (ngModelChange)="calculateItemTotal()"
                                [ngClass]="{'is-invalid': (total_charges.touched || contactDetailsForm.submitted) && total_charges.errors}"
                                required>
                            <div *ngIf="(total_charges.touched || contactDetailsForm.submitted) && total_charges.errors"
                                class="invalid-feedback">
                                <div *ngIf="total_charges.errors?.['required']">Total Charges is required.</div>
                            </div> -->
                            <input type="number" disabled class="form-control" name="total_charges" id="total_charges"
                                [value]="calculateItemTotal()">
                        </div>
                    </div>
                </div>

                <!-- ----------------------------------------------- -->
                <div class="row">
                    <div class="row mt-4">
                        <div class="" align="end">
                            <h6 class="blink"><i class="fa fa-plus"> Add More Suppliers</i></h6>
                        </div>
                        <div class="form-group">
                            <h4 class="page_heading">Technical RFP</h4>
                            <table class="table table-bordered tableBusiness">
                                <thead>
                                    <tr>
                                        <th>S. No.</th>
                                        <th>Question</th>
                                        <th>Points</th>
                                        <th>Weightage</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                    <tr *ngFor="let bom_map of bom.bomMapping; let i = index">
                                        <td>
                                            {{i+1}}
                                        </td>

                                        <td>
                                            <div class="form-group">
                                                <input type="text" class="form-control" name="specificationDetails"
                                                    placeholder="question" [(ngModel)]="bom_map.assetClass_id">
                                            </div>
                                        </td>

                                        <td>
                                            <div class="form-group">
                                                <input type="text" class="form-control" name="specificationDetails"
                                                    placeholder="number" [(ngModel)]="bom_map.assetCategories_id">
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-group">
                                                <input type="text" class="form-control" name="specificationDetails"
                                                    placeholder="Details" [(ngModel)]="bom_map.item_id">
                                            </div>
                                        </td>
                                        <td>
                                            <span class="fa_color_set mx-3" (click)="addRow()"><i
                                                    class="fa fa-plus-circle fa-2x"
                                                    style="color: rgb(63, 188, 230);"></i></span>
                                            <span class="fa_color_set1" (click)="removeRow(i)" *ngIf="i !== 0"><i
                                                    class="fa fa-minus-circle" style="color: red;"></i></span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="row mt-4">
                        <div class="form-group">
                            <h4 class="page_heading">Questioner</h4>
                            <table class="table table-bordered tableBusiness">
                                <thead>
                                    <tr>
                                        <th>S. No.</th>
                                        <th>Question</th>
                                        <th>Answer</th>
                                        <th>Correct Answer</th>
                                        <th>weightage</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <!-- <tr *ngFor="let questioner_map of questioner.questionerMapping; let i = index">
                                        <td>
                                            {{i+1}}
                                        </td>

                                        <td>
                                            <div class="form-group">
                                                <input type="text" class="form-control" name="specificationDetails"
                                                    placeholder="Question" [(ngModel)]="questioner_map.assetClass_id">
                                            </div>
                                        </td>

                                        <td>
                                            <div class="form-group">
                                                <select class="form-select" aria-label="Default select example"
                                                    name="specificationDetails"
                                                    [(ngModel)]="questioner_map.assetCategories_id">
                                                    <option [selected]="true" disabled>Select Vlaue</option>
                                                    <option value="1">YES</option>
                                                    <option value="2">NO</option>
                                                </select>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-group">
                                                <select class="form-select" aria-label="Default select example"
                                                    name="specificationDetails"
                                                    [(ngModel)]="questioner_map.assetCategories_id">
                                                    <option [selected]="true" disabled>Select Vlaue</option>
                                                    <option value="1">YES</option>
                                                    <option value="2">NO</option>
                                                </select>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-group">
                                                <input type="text" class="form-control" name="specificationDetails"
                                                    placeholder="number" [(ngModel)]="questioner_map.item_id">
                                            </div>
                                        </td>
                                        <td>
                                            <span class="fa_color_set mx-3" (click)="addRow1()"><i
                                                    class="fa fa-plus-circle fa-2x"
                                                    style="color: rgb(63, 188, 230);"></i></span>
                                            <span class="fa_color_set1" (click)="removeRow1(i)" *ngIf="i !== 0"><i
                                                    class="fa fa-minus-circle" style="color: red;"></i></span>
                                        </td>
                                    </tr> -->
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <!-- ---------------------------------------------------- -->
                <div class="row businessDetailPage mt-3">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="remark" class="form-label mandatory">Remark</label>
                            <textarea type="text" class="form-control" name="remark" id="remark" rows="4"
                                #remark="ngModel" [(ngModel)]="contact.remark"
                                [ngClass]="{'is-invalid': (remark.touched || contactDetailsForm.submitted) && remark.errors}"
                                style="overflow: hidden;" required></textarea>
                            <div *ngIf="(remark.touched || contactDetailsForm.submitted) && remark.errors"
                                class="invalid-feedback">
                                <div *ngIf="remark.errors?.['required']">Remark is required.</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-2 mt-4 text-center">
                        <label for="rfpUploadedFile" class="col-form-label">Upload Document</label>
                    </div>
                    <div class="col-md-4 mt-4">
                        <ng-container *ngFor="let item of rfpFile.vendorBiddingFiles; let i = index">
                            <div class="fileData circle-box">
                                <input type="file" class="form-control m-0" id="vendorBiddingFiles{{i}}"
                                    name="vendorBiddingFiles{{i}}" (change)="onFileChange($event, i)">
                                <div>
                                    <i class="fa-solid fa-file-circle-plus fa-xl" (click)="add()"></i>
                                </div>
                                <div>
                                    <i class="fa-solid fa-file-circle-minus fa-xl" (click)="remove(i)"></i>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>

            </fieldset>
        </form>
        <div class="d-flex justify-content-between backNextButton mt-3">
            <button routerLink="/vendor/manage-rfp/live" class="backButton">
                <i class="fa-solid fa-arrow-left"></i>&nbsp;<span> Back</span>
            </button>

            <button class="sumbitButton" type="submit" (click)="submit()">
                <i class="fa-solid fa-floppy-disk"></i>&nbsp;<span>Submit & Next</span>
            </button>
        </div>
    </section>
</div>